/**
 * Messages liés aux suggestions de publications
 */

module.exports = {

    status: {
        draft: 'Brouillon',
        enabled: 'Activée',
        disabled: 'Désactivée'
    },

    thematics: {
        product: 'Un produit / service',
        actuality: 'Une actualité',
        event: 'Un évènement',
        recruitment: 'Un recrutement',
        brand: 'Une marque'
    }

};
